import React from 'react';

import styled from 'styled-components';

import { GroupsProvider } from './GroupsContext';
import GroupsData from './GroupsData';
import GroupsHeader from './GroupsHeader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const Groups = () => {
  return (
    <Container>
      <GroupsProvider>
        <GroupsHeader />
        <GroupsData />
      </GroupsProvider>
    </Container>
  );
};

export default Groups;
